import Apartment from "../../../images/icons/flat.png";
import House from "../../../images/icons/house.png";
import Villa from "../../../images/icons/mansion.png";
import Boat from "../../../images/icons/house-boat.png";
import Camper from "../../../images/icons/camper-van.png";
import Cottage from "../../../images/icons/cottage.png";

export const accommodationData = {
  accommodation: {
    types: ["Villa", "House", "Apartment", "Boat", "Camper", "Cottage"],
    icons: {
      Villa,
      House,
      Apartment,
      Boat,
      Camper,
      Cottage,
    },
  },
};
